function showFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').show();
}

function hideFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').fadeOut(300);
}


function runWithLoader(task) {
  showFabricCanvasLoader();

  // frame 1 → show loader
  requestAnimationFrame(() => {
    // frame 2 → do heavy work
    requestAnimationFrame(() => {
      task();

      // hide loader AFTER render
      setTimeout(hideFabricCanvasLoader, 150);
    });
  });
}

var text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1400, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;


imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');





$(document).ready(function() {

  currentImage = null; 

  function loadImage(url) {
    if (currentImage) {
      canvas2.remove(currentImage);
    }
    fabric.Image.fromURL(url, function(img) {
      img.set({
        left: halfWidth,
        top: halfHeight,
        selectable: false
      });
    //   img.scale(1);
      canvas2.add(img);
      currentImage = img; 
      img.sendToBack();
      // window['text2Page'].bringToFront();
      canvas2.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  var defaultUrl = $('#base1 img').attr('data-src');
  if(defaultUrl) {
    loadImage(defaultUrl);
  }

  
  // On style change
  jQuery(document).on('change', 'input[name="Style"]', function(e) {
    var selectedVal = $(this).val();

    if (selectedVal === 'Without Base (Height 6 Width 9 inches)') {
      var blackUrl = $('#base1 img').attr('data-src');
      loadImage(blackUrl);
    } else {
      var woodenUrl = $('#base2 img').attr('data-src');
      loadImage(woodenUrl);
    }
  });

});



let starimage = document.querySelector("#stars_background");
let starBackground = new fabric.Image(starimage, {
  left: 150,   
  top: 180,
  scaleX: 1.53,
  scaleY: 1.53,
  selectable: false
});

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(starBackground);
starBackground.sendToBack();


addModify(window['canvas2']);


let isFirstRender = true;
let starMapGroup = null;

document.addEventListener("DOMContentLoaded", () => {
    if (!window['canvas2']) {
        console.error("canvas2 not found");
        return;
    }

    /* =============================== GLOBALS ================================ */
    let pickedCoords = { lat: 31.5546, lon: 74.3572 }; // Default Lahore
    let lastQueryId = 0;
    
    let starDatabase = [];
    let constellationLinesData = [];
    let isDataLoaded = false;

    const locationInput = document.getElementById("user_location");
    const suggestions = document.getElementById("suggestions");
    const dateInput = document.getElementById("moon_date");
    const coordsInput = document.getElementById("text_3");

    /* =============================== LOAD ASTRONOMY DATA ================================ */
    async function loadAstronomyData() {
        try {
            const starUrl = 'https://raw.githubusercontent.com/ofrohn/d3-celestial/master/data/stars.6.json';
            const linesUrl = 'https://raw.githubusercontent.com/ofrohn/d3-celestial/master/data/constellations.lines.json';

            const [starRes, linesRes] = await Promise.all([
                fetch(starUrl),
                fetch(linesUrl)
            ]);

            const starData = await starRes.json();
            const linesData = await linesRes.json();

            // 1. Parse Star Data
            starDatabase = {};
            starData.features.forEach(feature => {
                if (feature.geometry && feature.geometry.coordinates) {
                    const id = feature.id;
                    const coords = feature.geometry.coordinates;
                    starDatabase[id] = {
                        ra: coords[0],
                        dec: coords[1],
                        mag: feature.properties.mag
                    };
                }
            });

            // 2. Parse Constellation Lines
            constellationLinesData = [];
            
            linesData.features.forEach(f => {
                if (!f.geometry || !f.geometry.coordinates) return;
                let segments = [];
                if (f.geometry.type === 'LineString') {
                    segments = [f.geometry.coordinates];
                } else if (f.geometry.type === 'MultiLineString') {
                    segments = f.geometry.coordinates;
                }

                segments.forEach(segment => {
                    for (let i = 0; i < segment.length - 1; i++) {
                        const p1 = segment[i];
                        const p2 = segment[i+1];
                        constellationLinesData.push({
                            ra1: p1[0], dec1: p1[1],
                            ra2: p2[0], dec2: p2[1]
                        });
                    }
                });
            });

            isDataLoaded = true;
            updateStarMap(); 

        } catch (err) {
            console.error("Failed to load star data", err);
        }
    }

    loadAstronomyData();

    /* =============================== HELPERS ================================ */
    function formatCoords(lat, lon) {
        const latDir = lat >= 0 ? "N" : "S";
        const lonDir = lon >= 0 ? "E" : "W";
        return `${Math.abs(lat).toFixed(4)}° ${latDir} - ${Math.abs(lon).toFixed(4)}° ${lonDir}`;
    }

    function updateCanvasText(lat, lon) {
        if (window.text3Page) {
            window.text3Page.set("text", formatCoords(lat, lon));
            if (typeof fitTextToWidth3 === 'function') fitTextToWidth3(window.text3Page, 1250);
            window['canvas2'].renderAll();
        }
    }

    function updateCoordinatesInput(lat, lon) {
        if (coordsInput) coordsInput.value = formatCoords(lat, lon);
        updateCanvasText(lat, lon);
    }
    
    function updateLocationText(text) {
        if (window.text4Page) {
            window.text4Page.set("text", text);
            window.text4Page.bringToFront();
            window['canvas2'].renderAll();
        }
    }

    function updateDateText(dateStr) {
        if (window.text5Page) {
            const date = new Date(dateStr);
            if (!isNaN(date)) {
                const options = { day: "2-digit", month: "long", year: "numeric" };
                const formatted = date.toLocaleDateString("en-GB", options);
                window.text5Page.set("text", formatted);
                window.text5Page.bringToFront();
                window['canvas2'].renderAll();
            }
        }
    }

    /* =============================== AUTOCOMPLETE ================================ */
    if (locationInput) {
        locationInput.addEventListener("input", async (e) => {
            const q = e.target.value.trim();
            suggestions.innerHTML = "";
            suggestions.style.display = "none";
            if (q.length < 2) return;

            const queryId = ++lastQueryId;
            try {
                const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=6&q=${encodeURIComponent(q)}`);
                if (queryId !== lastQueryId) return;
                const data = await res.json();
                if (!data.length) return;

                suggestions.style.display = "block";
                data.forEach(place => {
                    const div = document.createElement("div");
                    div.className = "autocomplete-item";
                    div.textContent = place.display_name;
                    div.onclick = () => {
                        locationInput.value = place.display_name;
                        pickedCoords = { lat: parseFloat(place.lat), lon: parseFloat(place.lon) };
                        suggestions.style.display = "none";
                        updateCoordinatesInput(pickedCoords.lat, pickedCoords.lon);
                        
                        const parts = place.display_name.split(",");
                        const city = parts[0];
                        const country = parts[parts.length - 1];
                        updateLocationText(`${city}, ${country}`);
                        updateStarMap();
                    };
                    suggestions.appendChild(div);
                });
            } catch (e) { console.warn(e); }
        });
    }

    if (coordsInput) {
        coordsInput.addEventListener("input", function() {
            const val = this.value.trim();
            const m = val.match(/(-?\d+\.?\d*).*?([NS]).*?(-?\d+\.?\d*).*?([EW])/i);
            if (!m) return;
            let lat = parseFloat(m[1]); if (m[2].toUpperCase() === 'S') lat = -lat;
            let lon = parseFloat(m[3]); if (m[4].toUpperCase() === 'W') lon = -lon;
            pickedCoords = { lat, lon };
            updateStarMap();
        });
    }

    /* =============================== ASTRONOMY MATH ================================ */
    
    function getHorizonCoordinates(ra, dec, dateObj, lat, lon) {
        const observer = new Astronomy.Observer(lat, lon, 0);
        const raHours = ra / 15.0;
        const skyPos = Astronomy.Horizon(dateObj, observer, raHours, dec, 'normal');
        return { altitude: skyPos.altitude, azimuth: skyPos.azimuth };
    }

    function projectToCanvas(alt, az) {
        // Canvas Size: 1300x1300
        const center = 1400; 
        const mapRadius = 800; // Fill the square area

        // Projection math
        const zenithDist = (90.0 - alt);
        const r = (zenithDist / 90.0) * mapRadius;
        
        const azRad = az * Math.PI / 180.0;
        
        // FLIP FIX: Changed sin(az) to -sin(az) to mirror the map horizontally.
        // This creates the correct "looking up at the sky" orientation (East on Left).
        const x = center - r * Math.sin(azRad); 
        const y = center - r * Math.cos(azRad); 
        
        return { x, y };
    }

    function getStarMapClipPath() {

    const pathData = `M1352.3,1944.45c0-213.15,0-426.3,0-639.45c205.8,0,411.6,0,617.4,0c0,217.19,0,434.39,0,651.58
	c-3.31-1.72-8.34-1.65-7.45-7.6c-7.63,4.09-18.83-0.82-21.1-9.14c-0.83,0.27-2.05,0.28-2.4,0.84c-2.72,4.29-6.16,4.33-10.74,3.12
	c-1.95-0.52-4.71-1.09-6.53-0.78c-4.71,0.79-9.15,3.05-13.8,4.4c-1.67,0.49-3.61,0.07-5.43,0.07c-1.19,0-2.38,0.02-3.57,0.01
	c-5.03-0.02-10.07,0.15-15.09-0.13c-5.66-0.31-11.32-1.56-16.94-1.37c-3.12,0.11-6.16,2.32-9.25,3.57c-0.26,0.1-0.58,0.04-0.92,0.05
	c-0.24-1.42-0.47-2.81-0.75-4.48c-0.45,1.69-0.82,3.05-1.24,4.62c-2.2-0.7-4.74-0.74-5.89-2.02c-4.34-4.86-9.53-3.35-14.75-2.86
	c-4.35,0.41-8.74,0.56-13.11,0.67c-4.99,0.13-10.05-0.38-14.98,0.22c-7.8,0.94-15.5,2.71-23.29,3.79c-1.78,0.25-3.78-0.75-5.62-1.35
	c-2.8-0.9-5.56-1.95-8.34-2.94c-0.25,0.48-0.51,0.97-0.76,1.45c1.69,0.55,3.38,1.09,5.07,1.64c-0.61,0.76-1.22,1.52-1.83,2.28
	c-1.4,0.15-2.83,0.55-4.2,0.4c-3.73-0.43-7.13-1.5-11.03,0.83c-2.38,1.42-6.71,1.43-7-3.9c-0.04-0.67-3.02-2.04-4.07-1.63
	c-3.4,1.32-6.82,2.95-9.7,5.16c-3.85,2.95-4.88-0.56-6.93-2.39c-1.07,0.51-2.18,1.44-3.36,1.54c-7.88,0.7-16-2.41-23.72,1.54
	c-0.61,0.31-1.64-0.19-2.4-0.3c0-1.6,0-2.87,0-3.47c-3.14,0-5.9,0-8.66,0c-0.34-0.76-0.68-1.52-1.03-2.28
	c1.54-0.76,3.09-1.52,4.98-2.45c-7.79-0.97-14.26-7.94-22.12-1c1.61,0.97,2.79,1.68,3.94,2.37c-0.93,0.99-1.96,2.1-3.02,3.24
	c1.15,0.4,1.99,0.69,2.83,0.98c-0.09,0.35-0.18,0.7-0.28,1.04c-2.02-0.37-4.05-0.74-6.07-1.1c-0.27-0.51-0.55-1.01-0.82-1.52
	c1.06-0.6,2.12-1.21,3.17-1.81c-2.08,0.06-3.35,1.04-4.66,1.95c-1.44,1-2.96,2.81-4.37,2.75c-6.31-0.31-12.79-0.28-18.11-4.72
	c-1.1-0.92-3.51-0.93-3.91-1.93c-1.98-4.9-4.44-6.43-9.46-5.26c-3.31,0.77-6.81,2.35-9.93,1.83c-3.46-0.58-5.9-0.41-8.29,2.11
	c-0.84,0.89-2.06,1.58-3.24,1.95c-8.69,2.73-17.42,5.36-26.14,7.99c-0.63,0.19-1.7,0.42-1.97,0.11c-3.23-3.7-5.4-1.02-7.88,1.34
	c0.87,1.24,1.74,2.49,2.61,3.74c-0.3,0.49-0.6,0.98-0.9,1.48c-3.2-1.74-6.28-3.74-9.62-5.15c-3.88-1.63-7.98-2.74-11.99-4.07
	c0.11-0.39,0.22-0.78,0.33-1.18c2.5,0.21,5,0.43,7.5,0.64c0.03-0.53,0.06-1.06,0.08-1.58c-2.17-0.18-4.35-0.36-6.52-0.53
	c0.36-0.35,0.71-0.71,1.07-1.06c-2.08-2.34-3.83-6.04-6.32-6.63c-2.24-0.53-5.27,2.37-8.66,4.12c-5.03,0-11.5,0-17.96,0
	c0.04-0.29,0.07-0.57,0.11-0.86c2.14-0.58,4.28-1.15,6.41-1.73c-0.04-0.35-0.08-0.7-0.11-1.04c-1.35-0.43-2.69-0.86-4.04-1.28
	c2.07-1.25,4.42-0.58,5.79-1.44c1.35-0.86,2.11-3.24,2.27-5.03c0.05-0.56-2.69-1.37-4.15-2.07c-0.2,0.42-0.4,0.85-0.61,1.27
	c0.85,0.43,1.7,0.86,3.19,1.61c-5.34,1.07-9.94,1.84-14.46,2.93c-5.15,1.25-8.76-2.39-13.04-2.95c-5.34,1.08-10.83,1.65-16.25,2.63
	c-1.76,0.32-4.5,1.42-4.77,2.61c-0.89,3.97-2.64,4.3-6.23,3.43c-4.95-1.2-10.1-1.61-15.86-2.45c1.72-0.9,3.61-1.89,5.71-2.98
	c-3.31-1.02-6.19-1.9-9.06-2.78c0.16-0.44,0.32-0.89,0.48-1.33c1.28,0.06,2.56,0.13,4.62,0.23c-6.58-4.71-9.48-3.57-14.34,4.85
	c1.11,0.35,2.19,0.7,3.7,1.18c-4.68,1.78-8.71,3.76-12.97,4.81c-4.23,1.05-8.69,1.18-13.33,1.75c0.95-1.03,1.91-2.08,3-3.26
	c-1.14-0.73-1.89-1.64-2.63-1.63c-8.05,0.12-16.05-6.21-24.18-0.27c-0.35,0.26-1.1-0.09-1.6,0.06c-1.85,0.57-3.65,1.26-5.5,1.84
	c-1.22,0.38-3,1.34-3.63,0.86c-2.93-2.24-5.16-0.46-7.81,0.49c-3.17,1.14-6.67,1.35-9.88,2.42c-1.39,0.46-2.41,2.05-3.59,3.13
	c0,0-0.01-0.07-0.01-0.07c-3.72-0.55-7.45-1.09-10.95-1.61c-0.24-1.11-0.13-3.2-0.96-3.68c-0.93-0.54-2.7,0.37-4.11,0.65
	C1353.7,1944.2,1353,1944.32,1352.3,1944.45z M1606.48,1939.27c-5.04,1.84-10.09,3.68-15.13,5.52
	C1598.44,1948.53,1602.31,1943.43,1606.48,1939.27z M1680.9,1930.24c0.99,9.31,8.11,0.88,9.3,3.13
	C1688.36,1932.75,1684.94,1931.6,1680.9,1930.24z M1662.82,1935.97c-0.69-0.52-1.38-1.04-2.08-1.56c-1.51,2.65-3.02,5.29-4.93,8.63
	c1.99,0.21,4.07,0.43,7.23,0.77C1659.31,1941.05,1658.71,1938.49,1662.82,1935.97z`;

    const clip = new fabric.Path(pathData, {
        originX: "center",
        originY: "center",
        left: 0,   // adjust if needed
        top: 70,
        scaleX: 1.78,
        scaleY: 1.78,
        selectable: false
    });

    return clip;
}

    function drawStarMap() {
        if (!isDataLoaded) return;
        
        if (starMapGroup) window['canvas2'].remove(starMapGroup);
        const objs = [];

        // Date Logic: 22:00 (10 PM) standard for star posters
        const dateVal = dateInput ? dateInput.value : "2020-10-20";
        let dateObj = new Date(dateVal + " 22:00:00"); 
        
        const lat = pickedCoords.lat;
        const lon = pickedCoords.lon;

        // REMOVED: Background circle. 
        // The map will now render directly on the canvas without a circular mask/background.

        // 1. Prepare Stars
        const visibleStars = [];
        for (const id in starDatabase) {
            const star = starDatabase[id];
            if (star.mag > 5.5) continue; 

            const horizon = getHorizonCoordinates(star.ra, star.dec, dateObj, lat, lon);
            if (horizon.altitude > 0) {
                const pos = projectToCanvas(horizon.altitude, horizon.azimuth);
                visibleStars.push({ ...star, x: pos.x, y: pos.y });
            }
        }

        // 2. Draw Constellation Lines
        constellationLinesData.forEach(line => {
            const h1 = getHorizonCoordinates(line.ra1, line.dec1, dateObj, lat, lon);
            const h2 = getHorizonCoordinates(line.ra2, line.dec2, dateObj, lat, lon);

            if (h1.altitude > -5 && h2.altitude > -5) {
                const p1 = projectToCanvas(h1.altitude, h1.azimuth);
                const p2 = projectToCanvas(h2.altitude, h2.azimuth);

                objs.push(new fabric.Line([p1.x, p1.y, p2.x, p2.y], {
                    stroke: "rgba(0, 0, 0, 0.8)", 
                    strokeWidth: 2,
                    selectable: false,
                    evented: false
                }));
            }
        });

        // 3. Draw Stars
        visibleStars.forEach(s => {
            const radius = Math.max(2.2, (6 - s.mag) * 0.5); 
            objs.push(new fabric.Circle({
                left: s.x, top: s.y,
                radius: radius,
                fill: "black",
                originX: 'center', originY: 'center',
                selectable: false, evented: false
            }));
        });

        starMapGroup = new fabric.Group(objs, {
            originX: "center",
            originY: "center",
            left: 700,
            top: 700,
            objectCaching:false,
            selectable: false,
            evented: false
        });

        starMapGroup.clipPath = getStarMapClipPath();

        window['canvas2'].add(starMapGroup);
        starMapGroup.moveTo(1);

        window['canvas2'].renderAll();
    }

    function updateStarMap() {
        if (dateInput && !dateInput.value) return;
        if (typeof runWithLoader === 'function') runWithLoader(() => drawStarMap());
        else drawStarMap();
    }

    if (dateInput) {
        dateInput.addEventListener("change", function() {
            updateDateText(this.value);
            updateStarMap();
        });
    }

    updateCoordinatesInput(pickedCoords.lat, pickedCoords.lon);
    if (isDataLoaded) updateStarMap();
});



var maxWidth = 1000;
var maxHeight = 140;

var para = "check" ;

window['text2Page'] = new fabric.Text(para,{
  left: 680,
  top: 1445,
  width: 1000,
  fontSize: 75,
  fontFamily: 'Happy Birthday',
  // fontWeight: 'bolder',
  textAlign: 'center',
  isWrapping: true,
  fill: '#000'
});


var fontName = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName + "'").trigger('change');

window['canvas2'].add(window['text2Page']);


var minFontSize = 20;
var maxFontSize = 75;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Under this sky a star was born') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text2Page'].set({
    text: input
  });
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




window['text1Page'] = new fabric.Text('Shayan Jahangir',{
  left: 690,
  top: 1565,
  fontSize: 65,
  fontFamily: 'Dancing Script',
  underline: true,
  fill: '#000',
  // fontWeight: 'bolder',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font1').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Shayan Jahangir') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 65; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 950);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text4Page'] = new fabric.Text('Karachi, Pakistan',{
  left: 690,
  top: 1640,
  fontSize: 35,
  fontFamily: 'Poppins',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['canvas2'].add(window['text4Page']);


document.getElementById('user_location').addEventListener('focus', function () {
  if (window['text4Page'].text === 'Karachi, Pakistan') {
    window['text4Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


window['dateCoordsText'] = new fabric.Text(
  '22 May, 2025 | 24.8547° N - 67.0207° E',
  {
    left: 690,
    top: 1685,
    originX: 'center',
    fontSize: 32,
    fontFamily: 'Poppins',
    fill: '#000',
    lockMovementX: true,
    lockMovementY: true,
    hasControls: false,
    selectable: false
  }
);

window.canvas2.add(window['dateCoordsText']);

function updateDateAndCoords(dateText, coordsText) {

  const finalText = `${dateText} | ${coordsText}`;

  if(window.dateCoordsText){
    window.dateCoordsText.set('text', finalText);

    if(typeof fitTextToWidth3 === 'function'){
        fitTextToWidth3(window.dateCoordsText, 950);
    }

    window.dateCoordsText.bringToFront();
    window.canvas2.renderAll();
  }

}


function fitTextToWidth3(textObj, maxWidth) {
  let fontSize = 32;
  textObj.set({ fontSize });

  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window.canvas2.renderAll();
}





// window['text55Page'] = new fabric.Text('@tasweer.com.pk',{
//   left: 1330,
//   top: 1980,
//   fontSize: 14,
//   fontFamily: 'Baloo2',
//   fill: '#fff',
//   lockMovementX: true,
//   lockMovementY: true,
//   hasControls: false
// });


// window['canvas2'].add(window['text55Page']);




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

}

// jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(window['canvas2']);
  });

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    img = newImg;
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToWidth(window['text1Page'], 950);
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});


function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

function updateFont(activeOb){
  if(activeOb){
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',fontSize);
    activeOb.set('fontFamily',fontFamily);
    activeOb.set('fill',activeCOLOR);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});




jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Shayan Jahangir');
  window['text2Page'].set('text','Under this sky a star was born');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



/* fetch Call */
var size,thumbnail;
var loadedObject,moonDate,selectlocation,enterText,textFont,coordinates,enterQuote,quoteFont,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 406;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(currentImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    moonDate = jQuery('.moon_date input').val();
    selectlocation = jQuery('.location_map input').val();
    enterText = jQuery('.enter_text input').val();
    textFont = jQuery('.choose_font1 option:selected').val();
    coordinates = jQuery('.coordinates_map input').val();
    enterQuote = jQuery('.enter_quote textarea').val();
    quoteFont = jQuery('.choose_font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#moonDate').val(moonDate);
      jQuery('#selectlocation').val(selectlocation);
      jQuery('#enterText').val(enterText);
      jQuery('#textFont').val(textFont);
      jQuery('#coordinates').val(coordinates);
      jQuery('#enterQuote').val(enterQuote);
      jQuery('#quoteFont').val(quoteFont);
      jQuery('#addInfo').val(additionalInfo);
      console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
      loader.addClass('hidden');
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});



function resizeObjects(canvas){
  if (typeof starBackground !== 'undefined') starBackground.setCoords();
  if (typeof starMapGroup !== 'undefined') starMapGroup.setCoords();
  if (window['text1Page']) window['text1Page'].setCoords();
  if (window['text2Page']) window['text2Page'].setCoords();
  if (window['text4Page']) window['text4Page'].setCoords();
  if (window['dateCoordsText']) window['dateCoordsText'].setCoords();



  canvas.renderAll();

  var designResiz = new fabric.Group([starBackground,starMapGroup,window['text1Page'],window['text2Page'],window['text4Page'],window['dateCoordsText']].filter(Boolean));

  designResiz.set({
    left: halfWidth,
    top: 790,
    originX: 'center',
    originY: 'center'
  });

  designResiz.scaleToWidth(2060);
  designResiz.setCoords();
  canvas.renderAll();
}



function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(currentImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}